
import React, { Fragment, useState } from 'react'
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { updateConstraintsAction } from '@/Redux/Actions/ProgrammationManagerActions'
import { useTeams } from '@/Hooks/UseTeam'
import { addConstraint } from '@/Services/ProgrammationManagerService'

import Modal from '@/Components/Modal/Modal'
import Button from '@/Components/Button/Button'
import InputDropdown from '../../components/InputDropdown/InputDropdown'
import InputDropdownUser from '../../components/InputDropdown/InputDropdownUser'
import InputText from '../../components/InputText'
import InputSelect from '../../components/InputSelect'
import Textarea from '../../components/Textarea'
import InputDate from '../../components/InputDate/InputDate'

import AddICon from '../../../SvgImages/Add'

import './ConstraintCreator.scss'

interface Props {
  subTask?: any
}

const ConstraintCreator = ({ subTask }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const { users, allInternalProfiles } = useTeams()

  const [ showModal, setShowModal ] = useState(false)
  const [ name, setName ] = useState('')
  const [ description, setDescription ] = useState('')
  const [ family, setFamily ] = useState('general')
  const [ responsible, setResponsible ] = useState('')
  const [ responsibleModel, setResponsibleModel ] = useState<'User' | 'InternalProfile'>('User')
  const [ promiseDate, setPromiseDate ] = useState('')
  const [ requiredDate, setRequiredDate ] = useState('')
  const [ releaseDate, setReleaseDate ] = useState('')
  const [ creating, setCreating ] = useState(false)

  const task = subTask || itemOpened

  const familiesOptions = [
    { _id: 'general', name: t('CONSTRAINT_CREATOR:FamilyGeneral') },
    { _id: 'coordination', name: t('CONSTRAINT_CREATOR:FamilyCoordination') },
    { _id: 'resource', name: t('CONSTRAINT_CREATOR:FamilyResource') },
    { _id: 'time', name: t('CONSTRAINT_CREATOR:FamilyTime') },
    { _id: 'space', name: t('CONSTRAINT_CREATOR:FamilySpace') },
    { _id: 'design', name: t('CONSTRAINT_CREATOR:FamilyDesign') },
    { _id: 'logistic', name: t('CONSTRAINT_CREATOR:FamilyLogistic') },
  ]

  const handleResponsableChange = (responsable: string) => {

    console.log('responsable', responsable)

    const foundInUsers = users.find((u: any) => u._id === responsable)

    let responsableModel: 'User' | 'InternalProfile'

    if (foundInUsers) {
      responsableModel = 'User'
    } else  {
      responsableModel = 'InternalProfile'
    }

    setResponsible(responsable)
    setResponsibleModel(responsableModel)
  }

  const handleAddConstraint = async () => {

    setEditingItem(true)
    setCreating(true)

    const body = {
      name,
      description,
      family,
      responsible,
      responsibleModel,
      promiseDate,
      requiredDate,
      releaseDate,
    }

    const [ error, data ] = await addConstraint(task._id, body)

    setCreating(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    setName('')
    setDescription('')
    setFamily('general')
    setResponsible('')
    setPromiseDate('')
    setRequiredDate('')
    setReleaseDate('')

    if (!subTask) {
      patchItemOpened({
        restrictions: [...data.task.restrictions]
      })
    } else {
      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.restrictions = [...data.task.restrictions]
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateConstraintsAction({ task: data.task, parentTask: data.parentTask }))

    setShowModal(false)
  }

  const handleCancel = () => {

    setShowModal(false)

    setName('')
    setDescription('')
    setFamily('general')
    setResponsible('')
    setPromiseDate('')
    setRequiredDate('')
    setReleaseDate('')
  }

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className='mb-2'
      >
        <AddICon fill="#fff" height={24} width={24} />
      </Button>

      <Modal
        show={showModal}
        title={t('CONSTRAINT_CREATOR:Title')}
        onClose={handleCancel}
        backdropClassName='constraint-creator-backdrop'
        className='constraint-creator'
        showCloseButton={true}
      >
        <FormGroup>
          <FormLabel>
            {t('CONSTRAINT_CREATOR:LabelName')}
          </FormLabel>
          <InputText
            placeholder="Name"
            value={name}
            onChange={setName}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>
            {t('CONSTRAINT_CREATOR:LabelDescription')}
          </FormLabel>
          <Textarea
            value={description}
            onChange={setDescription}
            placeholder="Descripción"
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>
            {t('CONSTRAINT_CREATOR:LabelFamily')}
          </FormLabel>
          <InputSelect
            value={family}
            options={familiesOptions}
            onChange={setFamily}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>
            {t('CONSTRAINT_CREATOR:LabelAssignee')}
          </FormLabel>
          <InputDropdown
            value={responsible}
            placeholder="Responsible"
            options={[ ...users, ...allInternalProfiles ]}
            renderItem={(option: any) => (
              <InputDropdownUser
                user={option}
                isSelected={option._id === responsible}
              />
            )}
            onChange={(user_id: any) => {

              console.log('user_id', user_id)

              handleResponsableChange(user_id)
            }}
          />
          {/* <InputSelect
            placeholder="Responsible"
            value={responsible}
            options={users.map((u: any) => ({ _id: u._id, name: `${u.name} (${u.surname})` }))}
            onChange={setResponsible}
          /> */}
        </FormGroup>
        <Row className='mb-4'>
          <FormGroup as={Col} sm={4}>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelPromiseDate')}
            </FormLabel>
            {/* <InputDate
              value={promiseDate}
              onChange={setPromiseDate}
            /> */}
          </FormGroup>
          <FormGroup as={Col} sm={4}>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelRequiredDate')}
            </FormLabel>
            {/* <InputDate
              value={requiredDate}
              onChange={setRequiredDate}
            /> */}
          </FormGroup>
          <FormGroup as={Col} sm={4}>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelReleaseDate')}
            </FormLabel>
            {/* <InputDate
              value={releaseDate}
              onChange={setReleaseDate}
            /> */}
          </FormGroup>
        </Row>
        <Row>
          <Col style={{ textAlign: 'right' }}>
            <Button
              variant='primary'
              onClick={() => handleAddConstraint()}
              disabled={!name || !family || !responsible || creating}
            >
              <AddICon fill="#fff" height={24} width={24} />{' '}
              {!creating && t('CONSTRAINT_CREATOR:AddButton')}
              {creating && t('CONSTRAINT_CREATOR:AddButtonAdding')}
            </Button>
          </Col>
        </Row>
      </Modal>
    </Fragment>
  )
}

export default ConstraintCreator
